import button from './Button'
import input from './Input'
import inputMoney from './InputMoney'
import inputPassword from './InputPassword'
import select from './Select'
import radioGroup from './RadioGroup'
import calendar from './Calendar'
import toggleButton from './ToggleButton'
import optionsCheckbox from './OptionsCheckbox'
import selectSearch from './SelectSearch'
import selectSearchTrue from './SelectSearchTrue'
import fileInput from './FileInput'
import dropZone from './DropZone'
import inputImage from './InputImage'
import inputNumber from './InputNumber'
import inputPhone from './InputPhone'
import calendarDay from './CalendarDay'
import calendarDaySwal from './CalendarDaySwal'
import rangeCalendar from './RangeCalendar'
import rangeCalendarSwal from './RangeCalendarSwal'
import imageUpload from './ImageUpload'
import optionsCheckboxHeaders from './OptionsCheckboxHeaders'
import tagInput from './TagInput'
import tagSelectSearch from './TagSelectSearch'
import video from './Video'
import datePickerMulti from './DatePickerMulti'
import circleColor from './CircleColor'
import selectCreate from './SelectCreate'
import multipleRangeCalendar from './MultipleRangeCalendar'
import reactSelectSearch from './ReactSelectSearch'
import inputCantidad from './InputCantidad'
import tagSelectFixed from './TagSelectFixed'
// Validado, pero sin texto de error
import inputMoneySinText from './SinText/InputMoneySinText'
import selectSearchSinText from './SinText/SelectSearchSinText'
import inputNumberSinText from './SinText/InputNumberSinText'
import inputSinText from './SinText/InputSinText'
import selectCreateSinText from './SinText/SelectCreateSinText'
// Sin validar y sin texto de error
import inputGray from './Gray/InputGray'
import inputPhoneGray from './Gray/InputPhoneGray'
import selectSearchGray from './Gray/SelectSearchGray'
import doubleSelectSearchGray from './Gray/DoubleSelectSearchGray'
import inputMoneyGray from './Gray/InputMoneyGray'
import inputNumberGray from './Gray/InputNumberGray'
import radioGroupGray from './Gray/RadioGroupGray'
import tagInputGray from './Gray/TagInputGray'
import tagSelectSearchGray from './Gray/TagSelectSearchGray'
import selectCreateGray from './Gray/SelectCreateGray'
import inputPasswordGray from './Gray/InputPasswordGray'
import CalendarDayGray from './Gray/CalendarDayGray'
import CreatableMultiselectGray from './Gray/CreatableMultiselectGray'
import SelectSearchGrayTrue from './Gray/SelectSearchGrayTrue'
//TIempos
import selectMinutos from './SelectMinutos'
import selectHorasLaborales from './SelectHorasLaborales'
import selectHorario from './SelectHorario'
import selectAllHours from './SelectAllHours'
//Drive
import btnBackUrl from './Drive/BtnBackUrl'
import tablePagination from './Drive/TablePagination'
import newFolderInput from './Drive/NewFolderInput'
//Login
import inputLEmail from './Login/InputLEmail'
import inputLPassword from './Login/InputLPassword'
//XMLViewer
import fileXMLViewer from './FileXMLViewer'
import treeGrid from './TreeGrid'
// ReactSelect
import Single from './ReactSelect/ConIcono/Single'
import ReactSelectSearchGray from './Gray/ReactSelectSearchGray'
import FixedMultiOptionsGray from './Gray/FixedMultiOptionsGray'

export const Button = button
export const Input = input
export const InputMoney = inputMoney
export const InputPassword = inputPassword
export const Select = select
export const RadioGroup = radioGroup
export const Calendar = calendar
export const ToggleButton = toggleButton
export const OptionsCheckbox = optionsCheckbox
export const SelectSearch = selectSearch
export const SelectSearchTrue = selectSearchTrue
export const FileInput = fileInput
export const DropZone = dropZone
export const InputImage = inputImage
export const InputNumber = inputNumber
export const InputPhone = inputPhone
export const CalendarDay = calendarDay
export const CalendarDaySwal = calendarDaySwal
export const RangeCalendar = rangeCalendar
export const RangeCalendarSwal = rangeCalendarSwal
export const ImageUpload = imageUpload
export const OptionsCheckboxHeaders = optionsCheckboxHeaders
export const TagInput = tagInput
export const TagSelectSearch = tagSelectSearch
export const Video = video
export const DatePickerMulti = datePickerMulti
export const CircleColor = circleColor
export const SelectCreate = selectCreate
export const MultipleRangeCalendar = multipleRangeCalendar
export const ReactSelectSearch = reactSelectSearch
export const InputCantidad = inputCantidad
export const TagSelectFixed = tagSelectFixed
// Validado, pero sin texto de error
export const InputMoneySinText = inputMoneySinText
export const SelectSearchSinText = selectSearchSinText
export const InputNumberSinText = inputNumberSinText
export const InputSinText = inputSinText
export const SelectCreateSinText = selectCreateSinText
// Sin validar y sin texto de error
export const InputGray = inputGray
export const InputPhoneGray = inputPhoneGray
export const SelectSearchGray = selectSearchGray
export const DoubleSelectSearchGray = doubleSelectSearchGray
export const InputMoneyGray = inputMoneyGray
export const InputNumberGray = inputNumberGray
export const RadioGroupGray = radioGroupGray
export const TagInputGray = tagInputGray
export const TagSelectSearchGray = tagSelectSearchGray
export const SelectCreateGray = selectCreateGray
export const InputPasswordGray = inputPasswordGray
//Tiempos
export const SelectMinutos = selectMinutos
export const SelectHorasLaborales = selectHorasLaborales
export const SelectHorario = selectHorario
export const SelectAllHours = selectAllHours
//Drive
export const BtnBackUrl = btnBackUrl
export const TablePagination = tablePagination
export const NewFolderInput = newFolderInput
//Login
export const InputLEmail = inputLEmail
export const InputLPassword = inputLPassword
//XMLViewerFile
export const FileXMLViewer = fileXMLViewer
export const TreeGrid = treeGrid

export { CalendarDayGray, Single, CreatableMultiselectGray, ReactSelectSearchGray, SelectSearchGrayTrue, FixedMultiOptionsGray }